<template>
  <div></div>
</template>
<script>
export default {
  name: 'callback',

  created () {
    this.$router.replace({ path: '/' })
  }
}
</script>
